export default __webpack_public_path__ + "static/media/smartwatch.fb5eaee4.svg";